import _ from 'lodash';
import { getLegendCardinality, getXAxisRawValues } from '../data/data-util';
import { getEnvOptions } from '../env';
import { ErrorTypes } from './chart-data-validation';
import { getLegendColumns } from './chart-model-utils';
import { getChartSpecificCardinalityError } from './chart-type-specification-service';
export var callbackOwners;
(function (callbackOwners) {
    callbackOwners["AXIS_CONFIGURATOR"] = "AXIS_CONFIGURATOR";
    callbackOwners["CHART_SELECTOR"] = "CHART_SELECTOR";
})(callbackOwners || (callbackOwners = {}));
let cancelCallbacks = [];
let confirmCallbacks = [];
const getLimitCount = () => {
    const envOptions = getEnvOptions({});
    return envOptions.flags.maxChartLegendCardinality;
};
const addCallback = (callbackList, callbackOwner, callback) => {
    _.remove(callbackList, savedCallback => {
        if (savedCallback.label === callbackOwner) {
            return false;
        }
        return true;
    });
    callbackList.push({ callback, label: callbackOwner });
};
export const addCancelCallback = (callback, callbackOwner) => {
    addCallback(cancelCallbacks, callbackOwner, callback);
};
export const addConfirmCallback = (callback, callbackOwner) => {
    addCallback(confirmCallbacks, callbackOwner, callback);
};
const clearCallbacks = () => {
    confirmCallbacks = [];
    cancelCallbacks = [];
};
const testCardinalityValid = legendCount => {
    if (legendCount > getLimitCount()) {
        return false;
    }
    return true;
};
let showChartDialogCallback = _.noop;
export const setShowChartDialogCallbackHook = (fn) => {
    showChartDialogCallback = fn;
};
export const testLegendValid = (chartModel, dataModel) => {
    if (getLegendColumns(chartModel).length === 0) {
        return true;
    }
    const legendCount = getLegendCardinality(chartModel, dataModel);
    return testCardinalityValid(legendCount);
};
export const testXAxisLegendValid = (chartModel, dataModel) => {
    if (!dataModel) {
        return true;
    }
    const legendCount = new Set(getXAxisRawValues(dataModel)).size;
    return testCardinalityValid(legendCount);
};
export const getLegendCardinalityError = (chartModel, dataModel) => {
    const chartSpecificCardinalityErr = getChartSpecificCardinalityError(chartModel, dataModel);
    const cardinalityTooHigh = chartSpecificCardinalityErr === null
        ? !testLegendValid(chartModel, dataModel)
        : chartSpecificCardinalityErr;
    if (cardinalityTooHigh) {
        return { type: ErrorTypes.LEGEND_CARDINALITY_ERROR };
    }
    return null;
};
//# sourceMappingURL=cardinality-validation-service.js.map